import React from 'react';
import { ArrowDownRight, ArrowRight, Phone, MessageSquare } from 'lucide-react';
export const Vision = () => {
  return <section id="vision" className="py-20 bg-black relative overflow-hidden" data-id="element-278">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_rgba(255,255,255,0.03)_0,_transparent_70%)]" data-id="element-279"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-280">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-281">
          <h2 className="font-['Playfair_Display'] text-zinc-400 mb-4 tracking-wider text-sm" data-id="element-282">
            THE FUTURE OF LEGAL ASSISTANCE
          </h2>
          <h3 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-283">
            Every Lawyer Has a{' '}
            <span className="text-white" data-id="element-284">"Digital Assistant"</span>
          </h3>
          <p className="font-['Playfair_Display'] text-zinc-300 font-light" data-id="element-285">
            We envision a future where every lawyer has their own digital
            assistant—an AI that handles routine communications and
            administrative tasks, allowing attorneys to focus on practicing law
            rather than managing technology, regardless of whether intake is
            handled by in-house staff or a dedicated call center.
          </p>
        </div>
        <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 border border-white/10 rounded-sm p-8 md:p-12 backdrop-blur-sm" data-id="element-286">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-287">
            <div data-id="element-288">
              <h3 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-289">
                Like knights once relied on squires to prepare them for
                battle...
              </h3>
              <p className="font-['Playfair_Display'] text-zinc-300 mb-6 font-light" data-id="element-290">
                Tomorrow's lawyers will rely on AI to handle the operational
                burdens of intake, leaving them free to focus on the fight for
                their clients while working alongside their human team.
              </p>
              <p className="font-['Playfair_Display'] text-zinc-400 font-light" data-id="element-291">
                By augmenting your existing intake process with AI capabilities,
                LexSquire creates a more efficient experience that converts more
                leads while reducing the administrative burden on your legal
                professionals.
              </p>
            </div>
            <div className="relative" data-id="element-292">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-white/10 to-transparent rounded-sm blur-sm" data-id="element-293"></div>
              <div className="relative bg-black/80 border border-white/20 rounded-sm p-10 flex flex-col items-center justify-center text-center" data-id="element-294">
                <h4 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-295">
                  Discover Our Complete Vision
                </h4>
                <a href="/vision" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center" data-id="element-296">
                  Learn About Our Vision
                  <ArrowRight size={18} className="ml-2" data-id="element-297" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-298">
          <h3 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-299">
            Ready to enhance your firm's intake process with AI?
          </h3>
          <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-block" data-id="element-300">
            Schedule Demo
          </a>
          <p className="mt-4 text-zinc-300 font-['Playfair_Display']" data-id="element-301">
            Or try our AI intake specialist through any channel below:
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-6" data-id="element-302">
            <div className="flex items-center" data-id="element-303">
              <ArrowDownRight size={18} className="mr-2 text-zinc-400" data-id="element-304" />
              <p className="text-zinc-300 font-['Playfair_Display']" data-id="element-305">Chat</p>
            </div>
            <a href="tel:14159808760" className="flex items-center px-4 py-2 bg-zinc-800/50 hover:bg-zinc-700/50 transition-colors rounded-sm border border-white/10" data-id="element-306">
              <Phone size={16} className="mr-2" data-id="element-307" />
              <span className="font-['Playfair_Display']" data-id="element-308">Call AI</span>
            </a>
            <a href="sms:14159808760" className="flex items-center px-4 py-2 bg-zinc-800/50 hover:bg-zinc-700/50 transition-colors rounded-sm border border-white/10" data-id="element-309">
              <MessageSquare size={16} className="mr-2" data-id="element-310" />
              <span className="font-['Playfair_Display']" data-id="element-311">Text AI</span>
            </a>
          </div>
          <p className="mt-4 text-zinc-400 text-sm font-['Playfair_Display']" data-id="element-312">
            Experience firsthand what your clients will see when interacting
            with our AI
          </p>
        </div>
      </div>
    </section>;
};